import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TimelineState {
  timelineModalMode: 'sidePanel' | 'fullScreen';
}

const initialState: TimelineState = {
  timelineModalMode: 'sidePanel',
};

const timelineSlice = createSlice({
  name: 'timeline',
  initialState,
  reducers: {
    setTimelineModalMode: (state, action: PayloadAction<'sidePanel' | 'fullScreen'>) => {
      state.timelineModalMode = action.payload;
    },
    resetTimelineSettings: () => initialState,
  },
});

export const {
  setTimelineModalMode,
  resetTimelineSettings,
} = timelineSlice.actions;

export default timelineSlice.reducer;